import { connect } from 'react-redux';

import Component from './Integrations.component';
import { getClasslinkSettings, classlinkStateChanged, SAVE_CLASSLINK_SETTINGS } from '../+store/Integrations';
import { asyncFinish } from '../../common/+store/async';

const mapStateToProps = (state) => ({
  profile: state.modules.Auth.auth.profile,
  config: state.modules.Settings.integrations.classlinkConfig,
  liveState: state.modules.Settings.integrations.classlinkState,
  schoolList: state.modules.Settings.schoolSettings.schoolList,
});

const mapDispatchToProps = (dispatch) => ({
  getClasslinkSettings: () => {
    dispatch(getClasslinkSettings());
  },
  // The component calls the callables directly (inline error surfacing); this
  // lands the saved config in the store so the roster page banner stays in sync.
  configSaved: (data) => {
    dispatch(asyncFinish(SAVE_CLASSLINK_SETTINGS, data));
  },
  liveStateChanged: (liveState) => {
    dispatch(classlinkStateChanged(liveState));
  },
});

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Container;
